var map = {
	"./casino.png": "2687",
	"./casual.png": "7cad",
	"./coin.png": "f4d2",
	"./crown.png": "e599",
	"./deposit.png": "dcd0",
	"./dice.png": "aa39",
	"./fishing.png": "2b34",
	"./game.png": "9fcd",
	"./login.png": "0d6b",
	"./otp.png": "e548",
	"./p2p.png": "297b",
	"./password.png": "5d06",
	"./promotion.png": "c255",
	"./slot.png": "c8a3",
	"./support.png": "60b9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61b0";